import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'
import address from '@/store/shared/address'
import contactMedium from '@/store/shared/contactMedium'

export default {
  namespaced: true,
  state () {
    return {
      id: undefined,
      type: 'NP',
      residence: 'R',
      tradeName: undefined,
      name: undefined,
      lastName: undefined,
      document: undefined,
      settings: {
        mercantileRegistry: undefined,
        irpf: undefined,
        greenPoint: undefined,
        specialRegime: false,
        ticketbaiRequired: false,
        siiRequired: false,
        headingBizkaia: undefined
      },
      terms: undefined,
      issuedInvoices: undefined,
      maxIssuedInvoices: undefined
    }
  },
  actions,
  mutations,
  getters,
  modules: {
    address,
    contactMedium
  }
}
